/**
 * Component that is displayed when user has no Active Organization assigned
 */
import * as React from 'react';
import { Icon, Card, Button, message } from 'antd';
import '../css/NoActiveOrg.scss';
import service from '../service/apolloclient.service';
import strings from '../eyeguide-localization/organization/strings.organization';

export default class NoActiveOrganization extends React.Component<{}, {}> {
    render() {
        return(
            <div className="NoActiveOrg"> 
            <Card className="cardOverviewOwn ">
                <div className="centerItem">
                <div className="closeIcon">
                    <Icon type="close-circle" style={{ color: 'red' }}/>
                </div>
                <div className=" errorTest">
                    <span><h2 style={{fontWeight: 600}}>{strings.lsNoActiveOrgErrTxt}</h2> </span>
                </div>
                <div> 
                    <span> {strings.lsAccNotAssignedTxt} </span>
                </div>
                <div className="note">
                <div className="noteheading">
                    <span> {strings.lsPleaseNoteTxt} </span>
                </div>
                <div>
                    <Icon type="close-circle-o" style={{ fontSize: 14, color: 'red', marginRight: '5px' }}/>
                    <span>{strings.lsAccNotAssignedTxt} </span>
                </div>
                <div>
                    <Icon type="close-circle-o" style={{ fontSize: 14, color: 'red', marginRight: '5px' }}/>
                    <span>{strings.lsContactOrgTxt} </span>
                    <Button onClick={() => this.contactAdmin()} className="contactLink">
                        {strings.lsContactTxt} <Icon type="right" />
                    </Button>
                </div>
            </div>
            </div>
            </Card>
            </div>
        ) ;
    }

    /**
     * Calls API to send email to all Org admins
     */
    private async contactAdmin() {
        let ser = new service();
        let resp = await ser.contactAdmin();
        console.log('contactAdmin', resp);
        if (resp.status === 0) {
            message.success(strings.lsEmailSentToOrgTxt);
        } else {
            message.error(strings.lsPleaseTryAgainTxt);
        }
    }
    
}


// WEBPACK FOOTER //
// ./src/components/NoActiveOrg.tsx